var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 436.9 69.5",
    style: {
      enableBackground: "new 0 0 436.9 69.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:url(#planet_00000000222244097794700540000008075771214810649262_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.4,14.5c3,1.4,5.4,3.3,7,5.9c1.6,2.5,2.5,5.5,2.5,8.9c0,3.4-0.8,6.4-2.5,8.9c-1.6,2.5-4,4.5-7,5.8 c-3,1.4-6.6,2-10.7,2h-7.9V58h-12.9V12.4h20.8C149.8,12.4,153.3,13.1,156.4,14.5z M150.8,34.2c1.3-1.1,2-2.8,2-4.9 c0-2.1-0.7-3.8-2-4.9c-1.3-1.2-3.3-1.8-6-1.8h-7.2v13.3h7.2C147.5,35.9,149.5,35.4,150.8,34.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.2,9.7h12.4V58h-12.4V9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M220.9,26.1c3.1,2.7,4.6,6.8,4.6,12.3V58H214v-4.6c-1.8,3.4-5.2,5.1-10.4,5.1c-2.7,0-5.1-0.5-7.1-1.4 c-2-1-3.5-2.2-4.5-3.9c-1-1.6-1.5-3.5-1.5-5.6c0-3.3,1.3-5.9,3.8-7.8c2.6-1.8,6.5-2.8,11.8-2.8h7c-0.2-3.7-2.7-5.6-7.5-5.6 c-1.7,0-3.4,0.3-5.1,0.8c-1.7,0.5-3.2,1.3-4.4,2.2l-4.2-8.4c2-1.3,4.3-2.3,7.1-3s5.6-1.1,8.4-1.1 C213.4,22.1,217.9,23.5,220.9,26.1z M210.9,49.7c1.1-0.7,1.9-1.7,2.3-3.1v-3.1h-5.3c-3.6,0-5.4,1.2-5.4,3.6c0,1.1,0.4,2,1.2,2.6 c0.8,0.7,2,1,3.4,1S209.8,50.4,210.9,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M266.9,26c2.7,2.6,4,6.5,4,11.8V58h-12.4V39.8c0-4.8-1.9-7.2-5.8-7.2c-2.1,0-3.8,0.7-5.1,2.1 c-1.3,1.4-1.9,3.5-1.9,6.2v17h-12.4V22.7h11.8v3.8c1.4-1.4,3-2.5,4.9-3.3c1.9-0.8,4-1.1,6.2-1.1C260.7,22.1,264.2,23.4,266.9,26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M315,43.5h-25.6c0.5,1.8,1.5,3.2,3,4.2c1.5,1,3.4,1.5,5.6,1.5c1.7,0,3.2-0.2,4.4-0.7c1.2-0.5,2.5-1.3,3.7-2.3 l6.5,6.8c-3.4,3.8-8.4,5.7-15,5.7c-4.1,0-7.7-0.8-10.9-2.3s-5.5-3.7-7.3-6.5c-1.7-2.8-2.6-5.9-2.6-9.4c0-3.5,0.8-6.6,2.5-9.3 c1.7-2.8,4-4.9,6.9-6.5c2.9-1.6,6.3-2.3,9.9-2.3c3.5,0,6.7,0.7,9.6,2.2c2.9,1.5,5.1,3.6,6.8,6.3c1.7,2.8,2.5,6,2.5,9.8 C315.2,40.5,315.1,41.5,315,43.5z M291.6,32.5c-1.3,1.1-2.1,2.6-2.4,4.4h14.4c-0.3-1.9-1.2-3.3-2.4-4.4c-1.3-1.1-2.9-1.6-4.8-1.6 C294.5,30.9,292.9,31.5,291.6,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.2,56.5c-1,0.7-2.3,1.1-3.8,1.5c-1.5,0.3-3.1,0.5-4.8,0.5c-4.6,0-8.1-1.1-10.6-3.4 c-2.5-2.3-3.7-5.6-3.7-10.1V33.3h-5.1V24h5.1v-9.2h12.4V24h8.1v9.2h-8.1V45c0,1.3,0.3,2.2,1,3s1.6,1.1,2.7,1.1 c1.4,0,2.7-0.4,3.8-1.1L345.2,56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M360.2,22.7h-14V12.4H387v10.2h-13.9V58h-12.9V22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M436.9,12.4L417.4,58h-12.7l-19.4-45.5h13.9l12.4,29.7l12.6-29.7H436.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "planet_00000089534041370818541220000000862108766519009971_",
    gradientUnits: "userSpaceOnUse",
    x1: -364.9277,
    y1: 93.3994,
    x2: -365.5817,
    y2: 91.8016,
    gradientTransform: "matrix(54.412 0 0 -37.4042 19925.0801 3497.937)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9775FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5F3DC4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "planet",
    style: {
      fill: "url(#planet_00000089534041370818541220000000862108766519009971_)"
    },
    d: "M19.1,40.8 c-0.7-0.5-1.7-0.4-2.2,0.3c-0.3,0.4-0.4,0.8-0.3,1.3c4.2,18.7,22.8,30.5,41.6,26.2c0.9-0.2,1.8-0.4,2.7-0.7c0.8-0.3,1.3-1.1,1-2 c-0.1-0.4-0.5-0.8-0.9-1c-7.4-3.3-14.6-6.9-21.6-11C32.4,49.9,25.7,45.5,19.1,40.8L19.1,40.8z M97.3,51.2c-0.8-1.1-1.8-2.3-2.9-3.5 c-1.2-1.3-3.1-1.4-4.4-0.2c-0.4,0.3-0.7,0.8-0.8,1.2c0,0,0,0.1,0,0.1C88.7,50,89,51.2,89.7,52c4.5,4.9,5.2,7.6,5,8.2 c-0.4,0.4-3.4,1.4-11.5-0.7c-1.2-0.3-2.4-0.7-3.8-1.1c-0.9-0.3-1.8-0.6-2.7-0.9c1.5-1.7,2.7-3.5,3.9-5.4c0-0.1,0.1-0.1,0.1-0.2 c3-5.2,4.6-11.2,4.6-17.2c0-1.3-0.1-2.5-0.2-3.8C83,11.9,65.9-1.9,46.8,0.2c-11,1.2-20.8,7.5-26.3,17.1c0,0.1-0.1,0.1-0.1,0.2 c-1.1,1.9-2,3.9-2.7,6c-0.7-0.6-1.4-1.3-2.1-1.9c-1.1-1-2-1.9-2.8-2.8c-5.8-6-6.5-9-6.3-9.6C6.7,8.8,9.4,8.1,16,9.5 c1.1,0.3,2.3-0.2,3.1-1l0.1-0.1C20.2,7.1,20,5.1,18.7,4c-0.4-0.3-0.8-0.5-1.3-0.6c-1.6-0.4-3.1-0.6-4.7-0.8 C6.6,1.9,2.6,3.1,0.9,6.1c-0.9,1.7-1.1,3.8-0.5,5.6c1.1,4,4.8,8.8,10.2,13.8c1.7,1.6,3.6,3.2,5.6,4.9c1.4,1.2,3,2.4,4.5,3.6 c1,0.8,2.1,1.6,3.2,2.4c1.1,0.8,2.2,1.6,3.3,2.3c5,3.5,10.3,6.8,15.5,9.8c1.9,1.1,3.8,2.1,5.7,3.2c1.9,1,3.7,2,5.6,2.9 c4.3,2.2,8.6,4.1,12.6,5.8c1.7,0.7,3.4,1.4,5.1,2c2.3,0.9,4.6,1.6,6.8,2.3l0.2,0.1c4.1,1.3,8.4,2.1,12.7,2.4h0.3 c4.3,0,7.2-1.3,8.6-3.8C102,60.3,101,56.2,97.3,51.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1c7fd43676498aa1daddeeaba92172a2.svg";
export { ForwardRef as ReactComponent };